
    import { defineComponent } from 'vue'
    import { Field } from "vee-validate";

    export default defineComponent({
        inheritAttrs: false,
        components: {
            Field
        },
        directives: {
        },
        filters: {
        },
        props: {
            lastName: {
                type: String,
                default: '',
                required: true
            },
            firstName: {
                type: String,
                default: '',
                required: true
            },
            middleInitial: {
                type: String,
                default: '',
                required: true
            },
            suffix: {
                type: String,
                default: '',
                required: true
            },
            emailAddress: {
                type: String,
                default: '',
                required: true
            },
            userId: {
                type: String,
                default: '',
                required: true
            },
            password: {
                type: String,
                default: '',
                required: true
            },
            isUserIdNotAvailable: {
                type: Boolean,
                default: false
            },
            isUserIdChecking: {
                type: Boolean,
                default: false
            },
            disableUseridInput: {
                type: Boolean,
                default: false
            },
            isEmailAddressNotAvailable: {
                type: Boolean,
                default: false
            },
            isEmailAddressChecking: {
                type: Boolean,
                default: false
            },
        },
        emits: [
            'update:lastName',
            'update:firstName',
            'update:middleInitial',
            'update:suffix',
            'update:userId',
            'update:emailAddress',
            'update:password',
            'update:isUserIdAvailable',
            'useridInput',
            'emailAddressInput'
        ],
        expose: [
            '$refs'
        ],
        data() {
            return {
                confirmPassword: '' as string,
                emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ as RegExp
            }
        },
        computed: {
            computedLastNsme: {
                get(): string {
                    return this.lastName;
                },
                set(lastName: string): void {
                    this.$emit('update:lastName', lastName);
                }
            },
            computedFirstNsme: {
                get(): string {
                    return this.firstName;
                },
                set(firstName: string): void {
                    this.$emit('update:firstName', firstName);
                }
            },
            computedMiddleInitial: {
                get(): string {
                    return this.middleInitial;
                },
                set(middleInitial: string): void {
                    this.$emit('update:middleInitial', middleInitial);
                }
            },
            computedSuffix: {
                get(): string {
                    return this.suffix;
                },
                set(suffix: string): void {
                    this.$emit('update:suffix', suffix);
                }
            },
            computedEmailAddress: {
                get(): string {
                    return this.emailAddress;
                },
                set(emailAddress: string): void {
                    this.$emit('update:emailAddress', emailAddress);
                }
            },
            computedUserId: {
                get(): string {
                    return this.userId;
                },
                set(userId: string): void {
                    this.$emit('update:userId', userId);
                }
            },
            computedPassword: {
                get(): string {
                    return this.password;
                },
                set(password: string): void {
                    this.$emit('update:password', password);
                }
            },
            computedUserIdRightIcon(): string {
                if (!this.isUserIdNotAvailable && this.computedUserId && !this.isUserIdChecking) {
                    return 'circle-check';
                }
                else if (this.computedUserId && this.isUserIdChecking) {
                    return 'sync-alt';
                }
                return '';
            },
            computedUserIdRigtIconVariant(): string {
                if (!this.isUserIdNotAvailable && this.computedUserId && !this.isUserIdChecking) {
                    return 'success';
                }
                else if (this.isUserIdChecking) {
                    return 'danger';
                }
                return '';
            },
            computedEmailAddressRightIcon(): string {
                if (!this.isEmailAddressNotAvailable && this.computedEmailAddress && !this.isEmailAddressChecking && this.emailPattern.test(this.computedEmailAddress)) {
                    return 'circle-check';
                }
                else if (this.computedEmailAddress && this.isEmailAddressChecking) {
                    return 'sync-alt';
                }
                return '';
            },
            computedEmailAddressRigtIconVariant(): string {
                if (!this.isEmailAddressNotAvailable && this.computedEmailAddress && !this.isEmailAddressChecking) {
                    return 'success';
                }
                else if (this.isEmailAddressChecking) {
                    return 'danger';
                }
                return '';
            },
        },
        watch: {
        },
        created() {

        },
        mounted() {
        },
        updated() {
        },
        methods: {
            clearIconClick(): void {
                this.computedEmailAddress = '';
            },
        },
    });
